import { z } from 'zod';
export const translationGuard = z.lazy(() => z.record(z.string().or(translationGuard)));
